export class Password {
    current = "";
    new = "";
    confirm = "";
    isPwd = true;
}
